import React, { useContext, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './InternshipCta.module.scss';
import PathContext from '../../context/path';
import Popup from '../Popup';
import InternshipForm from '../InternshipForm';

const InternshipCta = (props) => {
  const {
    title = 'Не нашли подходящую стажировку?',
    desc = 'Заполните форму и мы свяжемся с вами, когда появится стажировка по выбранному направлению',
    buttonText = 'Заполнить форму',
    onButtonClick,
    className,
  } = props;
  const path = useContext(PathContext);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const wrapRef = useRef(null);

  // компонент монтируется динамически (после смены таба), поэтому глобальный
  // observer анимаций из Wrap.jsx его не подхватывает — навешиваем свой
  useEffect(() => {
    const el = wrapRef.current?.querySelector('[data-animate]');
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0% 100% -10% 100%' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handleButtonClick = (e) => {
    setIsPopupOpen(true);
    if (onButtonClick) onButtonClick(e);
  };

  return (
    <div
      ref={wrapRef}
      className={clsx(styles.wrap, className)}
      data-header-trigger={true}
    >
      <div className={styles.info} data-animate={'fade-in-up'}>
        <div className={styles.text}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.desc}>{desc}</p>
        </div>
        <button
          type="button"
          className={styles.btn}
          onClick={handleButtonClick}
        >
          {buttonText}
        </button>
      </div>
      <div className={styles.illustration} aria-hidden="true">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={`${path}/img/traineeship-cta-mobile.svg`}
          />
          <img src={`${path}/img/traineeship-cta.svg`} alt="" />
        </picture>
      </div>

      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
        <InternshipForm />
      </Popup>
    </div>
  );
};

export default InternshipCta;
